export default {
  error: 'Se han encontrado los siguientes problemas con los datos introducidos.Debe corregirlos para que se pueda efectuar correctamente la operación.'
}
